import { useMutation } from '@tanstack/react-query';
import { generateStoryAudio } from '@/services/storytime.service';

export const STORYTIME_GENERATE_AUDIO_MUTATION_KEY = 'storytime-generate-audio';

export const useGenerateStoryAudio = () => {
  return useMutation({
    mutationKey: [STORYTIME_GENERATE_AUDIO_MUTATION_KEY],
    mutationFn: ({ sessionId, language }: { sessionId: string; language: string }) =>
      generateStoryAudio(sessionId, language),
  });
};
